import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  LocationsAssigned,
} from 'vibeguide';

class BaselineLocations extends PureComponent {
  constructor(props) {
    super(props);

    const {
      locations,
      locationsData,
    } = props;

    this.state = {
      locations,
      locationsData,
    };
  }

  /**
   * When the locations are assigned from an object
   */
  onUpdateLocations = ({
    locations,
    locationsData,
  }) => {
    const {
      onUpdate,
    } = this.props;

    this.setState({
      locations,
      locationsData,
    });

    onUpdate({
      locations,
      locationsData,
    });
  };

  render() {
    const {
      companyId,
      scopeLimit,
      customToolbarAssigned,
      allowChanges,
      mediaFormat,
    } = this.props;

    const {
      locations,
      locationsData,
    } = this.state;

    return (
      <LocationsAssigned
        companyId={companyId}
        // send locations to use as a scope limit
        scopeLimit={scopeLimit}
        locations={locations}
        locationsData={locationsData}
        filtersUnassigned={{
          mediaFormat,
        }}
        customToolbar={customToolbarAssigned}
        disabled={!allowChanges}
        onUpdate={this.onUpdateLocations}
        allowACAF
        allowCompanies
      />
    );
  }
}

BaselineLocations.propTypes = {
  companyId: PropTypes.string,
  locations: PropTypes.arrayOf(PropTypes.object),
  locationsData: PropTypes.shape({
    companies: PropTypes.arrayOf(PropTypes.object),
    locations: PropTypes.arrayOf(PropTypes.object),
  }),
  mediaFormat: PropTypes.oneOf([
    'audio',
    'visual',
  ]),
  /** Locations to use as a limit when querying the API for available locations (Activate Baseline) */
  scopeLimit: PropTypes.arrayOf(PropTypes.object),
  customToolbarAssigned: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  allowChanges: PropTypes.bool,
  onUpdate: PropTypes.func,
};

BaselineLocations.defaultProps = {
  companyId: '',
  locations: [],
  locationsData: {
    companies: [],
    locations: [],
  },
  mediaFormat: 'audio',
  scopeLimit: [],
  customToolbarAssigned: null,
  allowChanges: false,
  onUpdate: () => {},
};

export default BaselineLocations;
